import { PageLayout } from '@kcftech/design-system';
import { DropdownTriggerOptions } from 'components/dropdown/Dropdown';
import { MediaQueries } from 'custom_hooks/useWindowSize';
import { dropdownTriggerStyles } from 'pages/Desk/issues/issue_modals/shared';
import { CSSProperties } from 'react';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const IssuesPageLayout = styled(PageLayout.Primary)`
    display: flex;
    flex-direction: column;
    height: auto !important;
    overflow-y: hidden !important;
    padding-bottom: 2rem;
    gap: 1.5rem;

    /* --- Begin: [ISSUE-CARD-BOX-SHADOW-FIX] ---
     * styles below this point are to prevent IssueGrid (card) boxshadow
     * styles from being chopped off by parent container bounding box
     */
    margin: 0 !important;
    /* restore the left and right margin ^ removed, via all the immediate
       children except for issues-list-scrollable, which will get special
       treatment */
    & > :not(.issues-list-scrollable) {
        margin-left: 2rem;
        margin-right: 2rem;
    }

    .issue-card {
        /* restore the left and right margin from before on the cards themselves.
           this spacing living here instead of on parent gives box-shadow room
           to exist */
        margin-left: 2rem;
        margin-right: 2rem;
        &:first-child {
            margin-top:  1rem;
        }

        &:last-child {
            margin-bottom: 1rem;
        }
    }

    .issues-list-scrollable {
        /* undo the above :first-child margin-top via its parent */
        margin-top: -1rem;
    }
    /* --- End: [ISSUE-CARD-BOX-SHADOW-FIX] --- */
`;

export const FilterAndSearchContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const UpdateAndSearchContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
`;

export const IssuesList = styled.div<{ $gridTemplateColumns?: string }>`
    display: grid;
    row-gap: 1.5rem;
    ${({ $gridTemplateColumns }) =>
        $gridTemplateColumns
            ? `grid-template-columns: ${$gridTemplateColumns};`
            : 'grid-template-columns: 1fr;'}

    @media ${MediaQueries.smallAndDown} {
        grid-template-columns: 1fr;
    }
`;

export const IconWrapper = styled.div<{ $backgroundColor: string; $padding?: string }>`
    width: 2rem;
    height: 2rem;
    padding: ${({ $padding }) => $padding ?? '1rem'};
    line-height: 2rem;
    border-radius: 50%;
    text-align: center;
    vertical-align: middle;
    background-color: ${({ $backgroundColor }) => $backgroundColor};
`;

export const Text = styled.div`
    font-size: 1.4rem;
`;

export const BoldText = styled(Text)`
    font-weight: 500;
`;

export const Separator = styled.div`
    border-right: 1px solid ${tokens.input.border};
`;

export function useIssueSidebarDropdownTriggerOptions(
    style?: CSSProperties,
): DropdownTriggerOptions {
    return {
        paddingOverride: '1.5y',
        style: { ...dropdownTriggerStyles, ...style },
    };
}
